export const legalPageOverrides = `
  .tp-static-page {
    width: 100%;
    max-width: none;
    margin: 0;
    color: #ffffff;
    background: transparent;
  }

  .tp-static-page,
  .tp-static-page p,
  .tp-static-page h1,
  .tp-static-page h2,
  .tp-static-page h3,
  .tp-static-page h4,
  .tp-static-page h5,
  .tp-static-page h6,
  .tp-static-page span,
  .tp-static-page div,
  .tp-static-page li {
    background: transparent;
    color: rgba(255, 255, 255, 0.9);
  }

  .tp-static-page article.page {
    width: min(860px, 100%);
    margin: 0 auto;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.02);
    box-shadow: none;
    overflow: hidden;
    padding: 24px 18px 28px;
  }

  .tp-static-page .tp-legal-meta-bar {
    width: 100%;
    margin: 0 0 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.03);
    padding: 10px 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .tp-static-page .tp-legal-updated {
    margin: 0;
    color: rgba(255, 255, 255, 0.72);
    font-size: 0.82rem;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  .tp-static-page .tp-legal-links {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .tp-static-page .tp-legal-links a {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.22);
    background-color: rgba(255, 255, 255, 0.05);
    color: #d7def2;
    font-size: 0.78rem;
    font-weight: 600;
    text-decoration: none;
    padding: 5px 9px;
  }

  .tp-static-page .tp-legal-links a:hover {
    background-color: rgba(102, 109, 236, 0.24);
    border-color: rgba(102, 109, 236, 0.5);
    color: #ffffff;
  }

  .tp-static-page .page-header-icon {
    width: 50px;
    height: 50px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.16);
    background: rgba(255, 255, 255, 0.05);
    margin-bottom: 12px;
  }

  .tp-static-page .page-title {
    margin-bottom: 0.35em;
    font-size: clamp(1.9rem, 4.2vw, 2.6rem);
    letter-spacing: -0.015em;
    color: #ffffff;
  }

  .tp-static-page h1,
  .tp-static-page h2,
  .tp-static-page h3 {
    color: #ffffff;
    letter-spacing: -0.01em;
  }

  .tp-static-page h1 {
    margin-top: 1.65rem;
    font-size: 1.72rem;
  }

  .tp-static-page h2 {
    margin-top: 1.35rem;
    font-size: 1.38rem;
  }

  .tp-static-page h3 {
    margin-top: 1.1rem;
    font-size: 1.16rem;
  }

  .tp-static-page .page-body {
    font-size: 0.98rem;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.78);
  }

  .tp-static-page .tp-legal-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .tp-static-page .tp-legal-toc {
    display: none;
  }

  .tp-static-page .tp-legal-toc-title {
    margin: 0;
    font-size: 0.78rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    font-weight: 700;
    color: #d7def2;
  }

  .tp-static-page .tp-legal-toc-list {
    margin: 10px 0 0;
    padding: 0;
    list-style: none;
    display: grid;
    gap: 4px;
  }

  .tp-static-page .tp-legal-toc-item {
    margin: 0;
  }

  .tp-static-page .tp-legal-toc-link {
    display: block;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 0.82rem;
    line-height: 1.4;
    text-decoration: none;
    padding: 6px 8px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
  }

  .tp-static-page .tp-legal-toc-link:hover {
    color: #ffffff;
    border-color: rgba(102, 109, 236, 0.5);
    background: rgba(102, 109, 236, 0.24);
  }

  .tp-static-page .tp-legal-toc-link.active {
    color: #ffffff;
    border-color: #666dec;
    background: #666dec;
  }

  .tp-static-page p {
    margin-top: 0.4rem;
    margin-bottom: 0.55rem;
  }

  .tp-static-page a,
  .tp-static-page a.visited {
    color: #66d1ec;
    text-decoration-color: rgba(102, 209, 236, 0.45);
    text-underline-offset: 3px;
  }

  .tp-static-page strong {
    color: #ffffff;
  }

  .tp-static-page ol,
  .tp-static-page ul {
    padding-left: 1.4rem;
    margin-block-start: 0.72em;
    margin-block-end: 0.72em;
  }

  .tp-static-page li {
    margin-bottom: 0.4rem;
  }

  .tp-static-page blockquote {
    margin: 0.8rem 0;
    padding: 0.7rem 0.9rem;
    border-left: 3px solid rgba(102, 109, 236, 0.6);
    background: rgba(102, 109, 236, 0.12);
    border-radius: 0 10px 10px 0;
    color: rgba(255, 255, 255, 0.86);
  }

  .tp-static-page hr {
    border-bottom-color: rgba(255, 255, 255, 0.12);
  }

  .tp-static-page table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    margin: 0.85rem 0;
    background: rgba(255, 255, 255, 0.02);
  }

  .tp-static-page th,
  .tp-static-page td {
    border-color: rgba(255, 255, 255, 0.12);
    padding: 0.42rem 0.55rem;
    color: rgba(255, 255, 255, 0.84);
  }

  .tp-static-page th {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.05);
    font-weight: 600;
  }

  @media (min-width: 1160px) {
    .tp-static-page article.page {
      width: min(980px, 100%);
      padding: 26px 22px 30px;
    }

    .tp-static-page .tp-legal-layout {
      grid-template-columns: 220px minmax(0, 1fr);
      gap: 16px;
      align-items: start;
    }

    .tp-static-page .tp-legal-toc {
      display: block;
      position: sticky;
      top: 96px;
      max-height: calc(100vh - 120px);
      overflow: auto;
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.02);
      padding: 12px 10px 10px;
    }
  }

  @media (max-width: 768px) {
    .tp-static-page article.page {
      border-radius: 16px;
      padding: 22px 14px 24px;
    }

    .tp-static-page .tp-legal-meta-bar {
      border-radius: 10px;
      padding: 9px 10px;
    }

    .tp-static-page .tp-legal-updated {
      font-size: 0.76rem;
    }

    .tp-static-page .tp-legal-links a {
      font-size: 0.72rem;
      padding: 4px 8px;
    }

    .tp-static-page .page-title {
      font-size: clamp(1.6rem, 7.6vw, 2.05rem);
    }

    .tp-static-page .page-body {
      font-size: 0.93rem;
      line-height: 1.68;
    }
  }
`;
